export { ReactComponent as CityCrest } from './city-crest.svg';
export { ReactComponent as PalermoCrest } from './palermo-crest.svg';
